var map = {
	"./about.svg": 9528,
	"./anonym.svg": 6112,
	"./array-right-long.svg": 5886,
	"./arrow-btm-long.svg": 1881,
	"./arrow-btm.svg": 7029,
	"./blockchain.svg": 8006,
	"./box.svg": 7324,
	"./center.svg": 5341,
	"./code.svg": 8993,
	"./cube-check.svg": 6336,
	"./cube-lock.svg": 5660,
	"./cube.svg": 6440,
	"./d-graph-m.svg": 2119,
	"./d-graph.svg": 2279,
	"./disk.svg": 979,
	"./gauss.svg": 1154,
	"./kube-block.svg": 6710,
	"./lock.svg": 7341,
	"./logo-dark.svg": 9432,
	"./logo-footer.svg": 6566,
	"./logo-text-dark.svg": 3588,
	"./logo-text.svg": 3370,
	"./logo.svg": 1972,
	"./mail.svg": 7896,
	"./people.svg": 5170,
	"./plus.svg": 3767,
	"./pyramid.svg": 6473,
	"./solution-m.svg": 8187,
	"./solution.svg": 1207,
	"./system.svg": 4395,
	"./tg.svg": 9085,
	"./twitter.svg": 7448,
	"./youtube.svg": 1271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;